var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95655 15.9995C3.11653 15.9995 0 12.8899 0 9.04298C0 5.20296 3.11653 2.08643 6.95655 2.08643C10.8035 2.08643 13.9131 5.20296 13.9131 9.04298C13.9131 12.8899 10.8035 15.9995 6.95655 15.9995ZM9.17595 11.624C9.25943 11.6727 9.34986 11.7005 9.44726 11.7005C9.62117 11.7005 9.79508 11.61 9.89248 11.4431C10.0386 11.1996 9.96204 10.8796 9.7116 10.7266L7.23507 9.25178V6.03785C7.23507 5.74568 6.99855 5.51611 6.71333 5.51611C6.42811 5.51611 6.19159 5.74568 6.19159 6.03785V9.55091C6.19159 9.73178 6.28898 9.89874 6.44898 9.99613L9.17595 11.624Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.56555,
    width: 2.78262,
    height: 1.39131,
    rx: 0.695655,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d9f4fc3c57289d423d8a19b344af8a21.svg";
export { ForwardRef as ReactComponent };